import React from 'react'
import useSWR from 'swr'
import { fetcher } from '@/hooks'
import Selector from '@/components/zthd/Selector'
import Skeleton from '@/components/ui/skeleton'
import { MultiSelect } from '@/components/ui/multi-select'

const DimensionSelect = ({
  dimension,
  value,
  onValueChange,
  label,
  className,
  packageName,
  pid,
  multiple = false,
}) => {
  const { data: options, isLoading } = useSWR(
    [`/admob/options/${dimension}`, { pid, packageName }],
    fetcher,
  )

  if (isLoading) {
    return <Skeleton className="h-10 w-[180px]" />
  }

  const selectOptions = [...(options || [])]

  if (multiple) {
    const selectedValues = Array.isArray(value) ? value : value ? [value] : []
    return (
      <div className={className}>
        <MultiSelect
          options={selectOptions}
          selected={selectedValues}
          onChange={onValueChange}
          placeholder={`Select ${label}...`}
        />
      </div>
    )
  }

  const selectorOptions = [
    { value: 'all', label: `All ${label}` },
    ...selectOptions,
  ]

  return (
    <Selector
      datas={selectorOptions.map((opt) => ({
        ...opt,
        code: opt.value,
        name: opt.label,
      }))}
      showLabel
      labelName={label}
      value={value}
      update={onValueChange}
      isSearchable={true}
      className={className}
    />
  )
}

export default DimensionSelect
